import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, task, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}/>
      <Notice
        display={task && task.archived}
        message={[
          'This task has been archived and is therefore no longer available.',
          task?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['task']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Tasks', link: routes.tasks.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: routes.archive.index},
  {title: 'Tasks', link: reverse(routes.archive.index, {tab: 'tasks'})}
];

export default Wrapper;
